import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Checkbox, Text } from '../../atoms';

const Label = styled.label`
  display: flex;
  align-items: center;
`;

const CheckField = ({ label, name }) => {
  return (
    <Label>
      <Checkbox
        name={name}
        style={{ marginRight: theme.spacing.xs, alignSelf: 'center' }}
      />
      <Text>{label}</Text>
    </Label>
  );
};

CheckField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default CheckField;
